import { render, staticRenderFns } from "./EditStoreGiftListComponent.vue?vue&type=template&id=ecaf2046&scoped=true"
import script from "./EditStoreGiftListComponent.vue?vue&type=script&lang=js"
export * from "./EditStoreGiftListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf2046",
  null
  
)

export default component.exports